<template>
  <div class="w98">
   <div class="crumb">
      <span><router-link to="/Help">帮助</router-link>  > </span>
      <span>本院影像</span>
    </div>
     <help-Menu></help-Menu>
    <div class="rightContent">
      <div class="conten">
          <p class="text">此模块归属于“资料中心”，用户可在此进行影像查询、影像调阅、影像标记、报告查看、以及相关历史影像查看、收藏影像到病例库等操作。</p>
            <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
                  影像查询
            </template>
            <div>
              <P  class="text">
                在下图中的查询条件中选择“检查时间（可自定义选择）、检查类型、就诊类别、选择医院”，也可输入“患者信息”，点击“查询”按钮，如果有结果，查询结果列表里会出现相应的结果，如果没有符合查询条件的结果，则页面上方会提示“未查询到符合条件的记录”。
              点击“重置”按钮，可以将查询条件恢复成默认状态。勾选“读片”，则查询结果列表只显示被标记过的影像。
              </P>
             </div>
            <div class="img"><img src="../../../../static/image/data.png"/></div>
          </el-collapse-item>
          <el-collapse-item title="影像操作">
            <div class="text">影像操作包含“报告、阅片、收藏、读片”四个操作，如图所示。</div>
            <div><img src="../../../../static/image/operation.png"/></div>
            <p class="text">1)点击查询结果列表中的“操作”字段中的“报告”按钮<b><img  class="littleImg"  src="../../../../static/image/63.png"/></b>（无报告时，按钮置灰，不可点击），页面跳转到“查看报告界面”，如下图所示。可进行申请单、历史检查、电子病历查看，支持多个检查同时对比阅片。</p>
              <img src="../../../../static/image/Check.png"/>
           <p class="text">2)点击查询结果列表中的“操作”字段中的“阅片”按钮<b><img  class="littleImg"  src="../../../../static/image/64.png"/></b>（无影像时，按钮置灰，不可点击），页面跳转到“阅片界面”，如下图所示。</p>
           <img src="../../../../static/image/readFilm.png"/>
          <p class="text">3)点击查询结果列表中的“操作”字段中的“收藏”按钮<b><img  class="littleImg"  src="../../../../static/image/65.png"/></b>，页面跳转到“收藏界面”，如下图所示，可收藏至典型病例库。</p>
           <img src="../../../../static/image/Collection.png"/>
          <p class="text">4)检查标记——点击查询结果列表中的“操作”字段中的“读片”按钮<b><img  class="littleImg"  src="../../../../static/image/66.png"/></b>，会跳出一个提示框，如图所示，点击“确定”按钮，病例标记成功，“读片”按钮变成实心<b><img  class="littleImg"  src="../../../../static/image/67.png"/></b>，标记过读片的病例可单独查询。</p>
           <img src="../../../../static/image/btn.png"/>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
</div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import helpHead from '@/components/common/header/helpHead'
  import helpMenu from '@/components/common/helpMenu/helpMenu'
  export default {
    data () {
      return {
         height:''
      }
    },
    components:{
        helpHead,
        helpMenu
    },
      mounted() {
      setTimeout(() => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      }, 20)
      window.addEventListener('resize', () => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      })
    },
}

</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.content
    min-width: 100vw
    height: 100vh
    overflow: hidden
  .rightContent
    position: relative
    float: right
    height :calc(100vh - 80px)
    width: calc(80% - 1px)
    min-width: 919px
    background :#fff
    overflow:auto
   .conten
      padding: 25px 25px 25px 30px
    img
      width:89%
  .littleImg
      width:30px
      vertical-align:middle
   .text
     color:#555
     line-height: 25px
     text-indent:2em
     margin-bottom:15px
 .crumb
 line-height: 30px
 margin: 5px 0 0 20px

</style>




// WEBPACK FOOTER //
// ImageHospital.vue?ac1c9310